(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/balance-view.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/balance-view.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Betslip = svs.components.tipsen.betslipComponents.Betslip;
const get = svs.components.account_balance.get;
const _React = React,
  useState = _React.useState;
const _svs$components$lbUti = svs.components.lbUtils.reactConditionals,
  Choose = _svs$components$lbUti.Choose,
  When = _svs$components$lbUti.When;
const currency = svs.utils.format.Currency;
const Icon = svs.ui.ReactIcon;
const WrapLoginLink = svs.components.lbUtils.wrapLoginLink.WrapLoginLink;
const _svs$components$tipse = svs.components.tipsen.walletSelectors,
  selectActiveWallet = _svs$components$tipse.selectActiveWallet,
  selectCommissionOptions = _svs$components$tipse.selectCommissionOptions;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$lbUti2 = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti2.useMediaQuery,
  breakpoints = _svs$components$lbUti2.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti2.BREAKPOINT_MD;
const WALLET_PLAYER = svs.components.tipsen.wallet.walletType.WALLET_PLAYER;
const roles = [svs.core.userSession.roles.PLAYER, svs.core.userSession.roles.RETAILER]; 

const isRetailer = svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER);
const isAnonymous = svs.core.userSession.isAnonymous();
const RetailerLabels = _ref => {
  let commissionPercent = _ref.commissionPercent;
  const commissionItems = useSelector(selectCommissionOptions);
  return React.createElement(React.Fragment, null, React.createElement("span", {
    className: "pg_betslip__balance_text"
  }, "Avgift: ".concat(commissionPercent, "%")), React.createElement("span", {
    className: "pg_betslip__balance_text"
  }, "Spelpott: ".concat(currency(commissionItems[commissionPercent].amount), " kr")));
};
const BalanceView = () => {
  var _activeWallet$meta, _activeWallet$meta2;
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    balance = _useState2[0],
    setBalance = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showBalance = _useState4[0],
    setShowBalance = _useState4[1];
  const activeWallet = useSelector(selectActiveWallet);
  const isPlayerWallet = (activeWallet === null || activeWallet === void 0 ? void 0 : activeWallet.type) === WALLET_PLAYER;
  const handleClick = () => {
    if (!showBalance && isPlayerWallet) {
      get(true, newBalance => setBalance(newBalance));
    }
    if (!isAnonymous) {
      setShowBalance(!showBalance);
    }
  };
  const qs = new URLSearchParams(window.location.search);
  const returnUrl = "".concat(window.location.pathname, "?").concat(qs);
  const walletBalance = currency(isPlayerWallet ? balance : activeWallet === null || activeWallet === void 0 || (_activeWallet$meta = activeWallet.meta) === null || _activeWallet$meta === void 0 ? void 0 : _activeWallet$meta.balance);
  return React.createElement(WrapLoginLink, {
    returnUrl: returnUrl,
    roles: roles
  }, React.createElement("div", {
    className: "pg_betslip__balance",
    onClick: handleClick
  }, React.createElement(Choose, null, React.createElement(When, {
    condition: showBalance
  }, React.createElement("div", {
    className: "pg_betslip__balance_label ".concat(isRetailer ? 'pg_betslip__balance_label--retailer' : '')
  }, React.createElement(Choose, null, React.createElement(When, {
    condition: !isRetailer
  }, !isPlayerWallet && React.createElement("span", {
    className: "pg_betslip__balance_text"
  }, activeWallet === null || activeWallet === void 0 ? void 0 : activeWallet.label), React.createElement(Icon, {
    className: "pg_betslip__balance_icon",
    color: "fc-white",
    icon: "balance",
    size: isSmallDevice ? '100' : '200'
  }), React.createElement("span", {
    className: "pg_betslip__balance_text margin-left"
  }, "".concat(walletBalance, " kr"))), React.createElement(When, {
    condition: isRetailer
  }, React.createElement(RetailerLabels, {
    commissionPercent: activeWallet === null || activeWallet === void 0 || (_activeWallet$meta2 = activeWallet.meta) === null || _activeWallet$meta2 === void 0 ? void 0 : _activeWallet$meta2.commissionPercent
  }))))), React.createElement(When, {
    condition: !showBalance
  }, React.createElement("div", {
    className: "pg_betslip__balance__hide"
  }, React.createElement(Icon, {
    className: "pg_betslip__balance__hide__icon",
    color: "fc-white",
    icon: "balance",
    size: isSmallDevice ? '100' : '200'
  }), React.createElement("span", {
    className: "margin-left pg_betslip__balance__hide__label"
  }, isRetailer ? 'Visa spelpott' : 'Visa saldo'))))));
};
Betslip.BalanceView = BalanceView;

 })(window);